/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

import template from './release-note-card.component.html';

@Component({
  standalone: false,
  selector: 'adn-release-note-card',
  template
})
export class ReleaseNoteCardComponent {
  @Input() note: any;
  @Input() singular = false;
  @Input() target = '';
}
